export default __webpack_public_path__ + "static/media/status-invisible.c334fb99.svg";